import { useState, useEffect } from "react"
import Select from 'react-select'
import api from '../../../utils/api'
import selectStyles from "../../css/SelectStyle"

// Select dos 27 estados + DF — a lista vem do backend (`/location/states`, fonte única
// compartilhada com o CitySelect) em vez de duplicada aqui.
function UfSelect({ value, onChange, selectName = 'state' }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const [options, setOptions] = useState([])

    useEffect(() => {
        api.get('/location/states', {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            setOptions((response.data.states || []).map((s) => ({ selectName, value: s.uf, label: `${s.uf} — ${s.name}` })))
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const selected = value ? (options.find((o) => o.value === value) || { value, label: value }) : ''

    return (
        <Select
            options={options}
            styles={selectStyles}
            onChange={onChange}
            value={selected}
            placeholder="UF..."
            menuPortalTarget={document.body}
            menuPosition="fixed"
        />
    )
}

export default UfSelect
